module.exports = "<div class=\"row text-center header\">\n  <h5>\n      <b>Confirm</b>\n  </h5>\n</div>\n<br>\n<div class=\"row text-center\">\n    <h5><b>Are You Sure Want to approved</b></h5>\n    <div class=\"row text-center\" style=\"float:right;padding-right:25px;\">\n      <button md-raised-button color=\"primary\" md-dialog-close>Continue</button>\n      <button md-raised-button class=\"btn_grey\" md-dialog-close>Cancel</button>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/dialogs/leave-confirm-dialog/leave-confirm-dialog.component.html
// module id = ../../../../../src/app/dialogs/leave-confirm-dialog/leave-confirm-dialog.component.html
// module chunks = main